import * as api from './api'

import React, { useEffect, useState } from 'react'

import { Select } from 'antd'
import { SelectValue } from 'antd/lib/select'

const { Option } = Select

interface Props {
  districtId: string | undefined
  onSelected?: (province: api.RegionEntity) => void
  onChange?: (value: SelectValue) => void
}

export const CommuneSelector = (props: Props) => {
  const { districtId } = props
  const [entities, setEntities] = useState<api.RegionEntity[]>([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (districtId) {
      getEntities()
    }
  }, [districtId])

  async function getEntities() {
    setLoading(true)
    const entities = await api.getCommunesByDistrictId(districtId)
    const sorted = entities.sort((a, b) => {
      return a.name.km.localeCompare(b.name.km)
    })
    setEntities(sorted)
    setLoading(false)
  }

  function onChange(value: SelectValue) {
    const commune = entities.find((p) => p.id === value)
    props.onSelected && props.onSelected(commune)
    props.onChange && props.onChange(commune.name.km)
  }

  return (
    <Select
      showSearch
      optionFilterProp="children"
      {...props}
      loading={loading}
      onChange={onChange}
    >
      {entities.map((entity) => {
        return (
          <Option key={entity.id} value={entity.id}>
            {`${entity.name.km}`}
          </Option>
        )
      })}
    </Select>
  )
}
